export type LastTouchedFieldType = 'withVat' | 'withoutVat' | undefined;
export type VatDeductibleFormFieldsLabel = Partial<{
  priceWoVat: string;
  priceWithVat: string;
  vatType: string;
}>;

/**
 * @internal
 * select only those paths, that includes `priceWithVat.amount`, `priceWoVat.amount` and `vatType` props
 */
export type PickValidKeys<T extends string> = {
  [P in T]: P extends `${infer Key}.priceWithVat.amount` ? Key : never;
}[T] &
  {
    [P in T]: P extends `${infer Key}.priceWoVat.amount` ? Key : never;
  }[T] &
  {
    [P in T]: P extends `${infer Key}.vatType` ? Key : never;
  }[T];

export type NestedKeyOf<ObjectType extends object> = {
  [Key in keyof ObjectType & (string | number)]: NonNullable<ObjectType[Key]> extends object
    ? `${Key}` | `${Key}.${NestedKeyOf<NonNullable<ObjectType[Key]>>}`
    : `${Key}`;
}[keyof ObjectType & (string | number)];
